import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    // Extracts pathname property (e.g., "/about", "/shop") from the current URL
    const { pathname } = useLocation();

    // Automatically runs whenever the pathname changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // This component doesn't render anything visually
    return null;
};

export default ScrollToTop;